export const industry_list = [
  {label: "Select Industry", value: 'industry'},
  {label: "Healthcare", value: "healthcare"},
  {label: "Financial", value: "financial"},
  {label: "Education", value: "education"},
  {label: "Government", value: "government"},
  {label: "Retail", value: "retail"},
  {label: "Technology", value: "technology"},
  {label: "Industrial", value: "industrial"},
  {label: "Professional Services", value: "professional_services"},
  {label: "Hospitality", value: "hospitality"},
  {label: "Insurance", value: "insurance"},
  {label: "Non-Profit", value: "non-profit"},
  {label: "Social Media", value: "social-media"},
  {label: "Other", value: "other"}
]

export const role_list = [
  {label: "Select Your Role", value: "your-role"},
  {label: "Founder / CEO / Owner", value: "owner"},
  {label: "Executive Manager", value: "executive-manager"},
  {label: "Compliance Manager", value: "compliance-manager"},
  {label: "Security Manager", value: "security-manager"},
  {label: "IT Manager", value: "it-manager"},
  {label: "Other", value: "other"}
]

export const country_list = [
  {label: "Select Country", value: "country"},
  {label: "Jamaica", value: "jamaica"}
]

export const pilot_packages = [
  {label: "Pilot Packages", value: "pilot-packages"},
  {label: "Monthly - $10,000 JMD", value: "monthly-$10,000JMD"},
  {label: "Annually - $96, 250 JMD", value: "annually-$96,250JMD"}
]


// WEBPACK FOOTER //
// ./src/utils/mock_data.js